import DespesasRotas from "./despesas/DespesasRotas"
import PagamentosRotas from "./pagamento/PagamentosRotas"

export default {
    path: 'requisitantes',
    name: 'DespesasGerais_Requisitantes',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [DespesasRotas, PagamentosRotas]
}